// FieldTargetTypeField.jsx

import React from 'react';

// Components
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';
import RichSelect from 'components/richselect/RichSelect';

/**
 * FieldTargetTypeField
 *
 * Renders the node type selector for nodelist form fields.
 *
 * @param {string} draftTargetType - The currently selected target node type key.
 * @param {object[]} targetTypeOptions - Available node type options.
 * @param {object} theme - Active theme values.
 * @param {string} error - Validation message for the field.
 * @param {boolean} disabled - Whether the select is disabled.
 * @param {function} onTargetTypeChange - Called when the selected node type changes.
 *
 * @returns {ReactNode} The rendered node type selector.
 */
const FieldTargetTypeField = ({
    draftTargetType,
    targetTypeOptions,
    theme,
    error,
    disabled,
    onTargetTypeChange,
}) => (

    <ModalField>

        <ModalLabel label="List Type" />
        <ModalHint hint="Select the type of list you want to create." />

        <RichSelect
            value={draftTargetType}
            options={targetTypeOptions}
            placeholder="Select a node type"
            style={{ width: '100%' }}
            disabled={disabled}
            error={!!error}
            helperText={error}
            onValueChange={(value) => onTargetTypeChange(value)}
        />

    </ModalField>

);

export default FieldTargetTypeField;